"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _anchor = _interopRequireDefault(require("../../styles/anchor"));
var _Chevron = _interopRequireDefault(require("../../icons/Chevron"));
var _theme = _interopRequireDefault(require("../../theme"));
var _focus = require("../../styles/focus");
var _excluded = ["variant", "direction", "color"],
  _excluded2 = ["direction", "variant", "color"],
  _excluded3 = ["children", "variant", "direction", "color"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var StyledA = (0, _styledComponents["default"])(function (_ref) {
  var variant = _ref.variant,
    direction = _ref.direction,
    color = _ref.color,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("a", rest);
}).withConfig({
  displayName: "LinkWithChevron__StyledA",
  componentId: "sc-iokz12-0"
})(["", ";flex-direction:", ";color:", ";display:inline-flex;font-family:", ";align-items:center;font-size:", ";&:hover{color:", ";}&:active,&:focus{border-radius:", ";", "}"], _anchor["default"], function (_ref2) {
  var direction = _ref2.direction;
  return direction === 'right' ? 'row' : 'row-reverse';
}, function (_ref3) {
  var color = _ref3.color;
  return color === 'dark' ? _theme["default"].indigo60 : '#FFFFFF';
}, _theme["default"].nunito, function (_ref4) {
  var variant = _ref4.variant;
  return variant === '100' ? '1.6rem' : '1.8rem';
}, function (_ref5) {
  var color = _ref5.color;
  return color === 'dark' ? _theme["default"].indigo80 : '#FFFFFF';
}, _theme["default"].borderRadiusSmall, _focus.focusOutlineStyle);
var StyledChevron = (0, _styledComponents["default"])(function (_ref6) {
  var direction = _ref6.direction,
    variant = _ref6.variant,
    color = _ref6.color,
    rest = _objectWithoutProperties(_ref6, _excluded2);
  return /*#__PURE__*/_react["default"].createElement(_Chevron["default"], _extends({
    direction: direction,
    "aria-hidden": "true",
    color: color === 'dark' ? _theme["default"].indigo60 : '#FFFFFF',
    size: variant === '100' ? 12 : 14
  }, rest));
}).withConfig({
  displayName: "LinkWithChevron__StyledChevron",
  componentId: "sc-iokz12-1"
})(["margin-top:1px;", ""], function (_ref7) {
  var direction = _ref7.direction,
    variant = _ref7.variant;
  if (direction === 'right') {
    return "margin-left: ".concat(variant === '100' ? '7px' : '10px');
  }
  return "margin-right: ".concat(variant === '100' ? '7px' : '10px');
});
var LinkWithChevron = function LinkWithChevron(_ref8) {
  var children = _ref8.children,
    _ref8$variant = _ref8.variant,
    variant = _ref8$variant === void 0 ? '100' : _ref8$variant,
    _ref8$direction = _ref8.direction,
    direction = _ref8$direction === void 0 ? 'right' : _ref8$direction,
    _ref8$color = _ref8.color,
    color = _ref8$color === void 0 ? 'dark' : _ref8$color,
    props = _objectWithoutProperties(_ref8, _excluded3);
  return /*#__PURE__*/_react["default"].createElement(StyledA, _extends({}, props, {
    variant: variant,
    direction: direction,
    color: color
  }), children, /*#__PURE__*/_react["default"].createElement(StyledChevron, {
    direction: direction,
    variant: variant,
    color: color
  }));
};
LinkWithChevron.propTypes = {
  variant: _propTypes["default"].oneOf(['100', '120']),
  children: _propTypes["default"].node.isRequired,
  href: _propTypes["default"].string.isRequired,
  direction: _propTypes["default"].oneOf(['left', 'right']),
  onClick: _propTypes["default"].func,
  target: _propTypes["default"].oneOf(['_blank', '_self', '_parent', '_top']),
  rel: _propTypes["default"].string,
  color: _propTypes["default"].oneOf(['light', 'dark'])
};
var _default = exports["default"] = LinkWithChevron;